import React from 'react';
import { Videoteka } from '~/src/components/Videoteka';
import * as S from './styled';

export const Subscriptions = () => {
    return (
        <S.Section bgColor='#000'>
            <S.InnerContainer>
                <S.SectionTitle isLight>Тематические подписки</S.SectionTitle>
                <Videoteka/>
            </S.InnerContainer>
        </S.Section>
    );
};
